import { getData } from "@/utils";
import moment from "moment";

export async function getMultipleAnalyticsPosMetric(params) {
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=month`;
  let locationQueryString = params.pos_ids
    .map(location => `${location.value}`)
    .join(",");
  let apiUrl = `/benchmark/analytics/pos/avgv2?${queryString}&pos_ids=${locationQueryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMultipleAnalyticsPosMetricV2(params) {
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=month&isLocationOrLocationGroups=${params.isLocationOrLocationGroups}`;
  let locationQueryString = "";
  let apiUrl = `/benchmark/analytics/pos/avgv2?${queryString}`;
  if (params.isLocationOrLocationGroups == 'locations'){
    locationQueryString = params.pos_ids
    .map(location => `${location.value}`)
    .join(",");  
    apiUrl = apiUrl.concat(`&pos_ids=${locationQueryString}`)
  }
  else if (params.isLocationOrLocationGroups == 'location_groups'){
    locationQueryString = params.location_group_ids
    .map(location_group => `${location_group.value}`)
    .join(",");    
    apiUrl = apiUrl.concat(`&location_group_ids=${locationQueryString}`)
  }
  // let apiUrl = `/benchmark/analytics/pos/avgv2?${queryString}&pos_ids=${locationQueryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMultipleAnalytics(params, locations, yearOver = '') {
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let locationQueryString = locations
    .map(location => `pos_id=${location.value}`)
    .join("&");
  let apiUrl = `/benchmark/analytics-weekly-api/?${queryString}&${locationQueryString}`;
  
  if (yearOver != '' && yearOver === 2){
      apiUrl = `/benchmark/analytics-weekly-api-y2/?${queryString}&${locationQueryString}`    
  }

  try {
    const response = await getData(apiUrl);

    return response;
  } catch (e) {
    return null;
  }
}

// export async function getMultipleAnalyticsAvg(params, locations, yearOver = '') {
//   let queryString = Object.keys(params)
//     .map(function (key) {
//       return `${key}=${params[key]}`;
//     })
//     .join("&");
//   let locationQueryString = locations
//     .map(location => `pos_id=${location.value}`)
//     .join("&");
//   let apiUrl = `/benchmark/analytics-weekly-api/avg?${queryString}&${locationQueryString}`;
  
//   if (yearOver != '' && yearOver === 2){
//     apiUrl = `/benchmark/analytics-weekly-api-y2/?${queryString}&${locationQueryString}`    
//   } 
//   try {
//     const response = await getData(apiUrl);

//     return response;
//   } catch (e) {
//     return null;
//   }
// }

export async function getMultipleAnalyticsAvg(params, locations, yearOver = '',locationGroups,locationOrLocationGroups) {
  console.log("getMultipleAnalyticsAvg",locations,locationGroups,locationOrLocationGroups);
  params.isLocationOrLocationGroups = locationOrLocationGroups;
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrlBase = `/benchmark/`;
  let apiUrl = '';
  if(locationOrLocationGroups == 'locations'){
    let locationQueryString = locations
      .map(location => `pos_id=${location.value}`)
      .join("&");
    let apiEndpoint1 = `analytics-weekly-api/avg?${queryString}&${locationQueryString}`;
    apiUrl = apiUrlBase.concat(apiEndpoint1);
    
    if (yearOver != '' && yearOver === 2){
      let apiEndpoint2 = `analytics-weekly-api-y2/?${queryString}&${locationQueryString}`;
      apiUrl = apiUrlBase.concat(apiEndpoint2);
    } 
  }
  else if(locationOrLocationGroups == 'location_groups'){
    let locationGroupQueryString = locationGroups
      .map(locationGroup => `location_group_id=${locationGroup.value}`)
      .join("&");
      let apiEndpoint1 = `analytics-weekly-api/avg?${queryString}&${locationGroupQueryString}`;
      apiUrl = apiUrlBase.concat(apiEndpoint1);
      
      if (yearOver != '' && yearOver === 2){
        let apiEndpoint2 = `analytics-weekly-api-y2/?${queryString}&${locationGroupQueryString}`;
        apiUrl = apiUrlBase.concat(apiEndpoint2);
      } 
  }
  try {
    const response = await getData(apiUrl);

    return response;
  } catch (e) {
    return null;
  }
}

export async function getMultipleAnalyticsRegionMetric(params) {
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=month`;
  let locationQueryString = params.pos_ids
    .map(location => `${location.value}`)
    .join(",");
  let apiUrl = `/benchmark/analytics/region/avgv2?${queryString}&pos_ids=${locationQueryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMultipleAnalyticsRegionMetricV2(params) {
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=month&isLocationOrLocationGroups=${params.isLocationOrLocationGroups}`;
  let locationQueryString = "";
  let apiUrl = `/benchmark/analytics/region/avgv2?${queryString}`;
  if (params.isLocationOrLocationGroups == 'locations'){
    locationQueryString = params.pos_ids
    .map(location => `${location.value}`)
    .join(",");
    apiUrl = apiUrl.concat(`&pos_ids=${locationQueryString}`);
  }
  else if (params.isLocationOrLocationGroups == 'location_groups'){
    locationQueryString = params.location_group_ids
    .map(location_group => `${location_group.value}`)
    .join(",");    
    apiUrl = apiUrl.concat(`&location_group_ids=${locationQueryString}`);
  }
  // let apiUrl = `/benchmark/analytics/region/avgv2?${queryString}&pos_ids=${locationQueryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getRecommendations(params) {
  try {
    let dateRangeString = `start_date=${params.start_date}&end_date=${params.end_date}`;
    let queryString = params.location_ids
      .map(location_id => `location_id=${location_id}`)
      .join("&");
    let apiUrl = `/benchmark/recommendations-api/?${dateRangeString}&${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getDemographics(location_id = null) {
  if (!location_id) return null;
  try {
    const response = await getData(
      `/benchmark/demographics-api/?location_id=${location_id}`
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsDefault() {
  const response = await getData(`/benchmark/analytics-api/`);
  return response;
}

export async function getAnalyticsY2Default() {
  const response = await getData(`/benchmark/analytics-api-y2/`);
  return response;
}

export async function getAnalytics(params, yearOver = '') {
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics-weekly-api/?${queryString}`;
  if (yearOver != '' && yearOver === 2){
      apiUrl = `/benchmark/analytics-weekly-api-y2/?${queryString}`;
  }
  // if (numDays >= 60) {
  //   apiUrl = `/benchmark/analytics-weekly-api/?${queryString}`;
  // } else {
  //   apiUrl = `/benchmark/analytics-daily-api/?${queryString}`;
  // }
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsAvg(params, yearOver = '') {
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics-weekly-api/avg?${queryString}`;
  if (yearOver != '' && yearOver === 2){
    apiUrl = `/benchmark/analytics-weekly-api-y2/?${queryString}`;
  }
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsMinMaxDates(params, locations,locationGroups,locationOrLocationGroups) {
  console.log("getAnalyticsMinMaxDates",locations,locationGroups,locationOrLocationGroups)
  // params.isLocationOrLocationGroups = locationOrLocationGroups;
  
  let locationQueryString = ''
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics/dates/?isLocationOrLocationGroups=${locationOrLocationGroups}&${queryString}&`;
    if(locationOrLocationGroups == 'locations'){
      if (locations != undefined) {
        locationQueryString = locations
          .map(location => `pos_id=${location.value}`)
          .join("&");
        apiUrl = apiUrl.concat(locationQueryString);
      }
      
    }
    else if(locationOrLocationGroups == 'location_groups'){
      let locationGroupQueryString = locationGroups
        .map(locationGroup => `location_group_id=${locationGroup.value}`)
        .join("&");
        apiUrl = apiUrl.concat(locationGroupQueryString);
    }
  
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsHeatmap(params) {
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics/analytics-heatmap?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsPosMetric(params) {
  let apiUrl = "";
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");

  apiUrl = `/benchmark/analytics/pos-month?${queryString}`;

  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsPosMetricV2(params) {
  let apiUrl = "";
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  apiUrl = `/benchmark/analytics/pos-month?${queryString}`;

  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsPosMetricAvgV2(params) {
  let apiUrl = "";
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");

  apiUrl = `/benchmark/analytics/pos/avgv2?${queryString}`;  

  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsPosMetricAvg(params) {
  let apiUrl = "";
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");

  apiUrl = `/benchmark/analytics/pos/avg?${queryString}`;

  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}


export async function getAnalyticsRegionMetric(params) {
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics/regionv2?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsRegionMetricV2(params) {
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics/regionv2?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAnalyticsRegionMetricAvg(params) {
  params.period = "week";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/analytics/region/avg?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getTotalSalesYoY(params, yearOver = '') {
  // console.log("params", params);
  delete params.period;
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=week&campaign_id=${params.campaign_id}&isLocationOrLocationGroups=${params.isLocationOrLocationGroups}`;
  let locationQueryString = "";
  if (params.isLocationOrLocationGroups == 'locations'){
    if (params.pos_ids && params.pos_ids.length > 0) {
      locationQueryString =
        "&pos_ids=" +
        params.pos_ids.map(location => `${location.value}`).join(",");
    } else {
      queryString = queryString + `&pos_id=${params.pos_id}`;
    }
  }
  else if (params.isLocationOrLocationGroups == 'location_groups'){
    if (params.location_group_ids && params.location_group_ids.length > 0) {
      locationQueryString =
        "&location_group_ids=" +
        params.location_group_ids.map(location_group => `${location_group.value}`).join(",");
    } else {
      queryString = queryString + `&location_group_ids=${params.location_group_ids}`;
    }
  }
  let apiUrl = `/benchmark/weekly-total-sales-yoy-old/?${queryString}${locationQueryString}`;
  //let apiUrl = `/benchmark/monthly-total-sales-yoy/?${queryString}${locationQueryString}`;

  if (yearOver != '' && yearOver === 2){
    apiUrl = `/benchmark/weekly-total-sales-yo2y/?${queryString}${locationQueryString}`;
  }
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMarketingRecommendations(params) {
  try {
    let queryString = Object.keys(params)
      .map(function (key) {
        return `${key}=${params[key]}`;
      })
      .join("&");

    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    const apiUrl = `/benchmark/marketing-recommendations/?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}


export async function getDailyTotalSalesYoY(params, yearOver = '') {
  // console.log("params", params);

  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&campaign_id=${params.campaign_id}`;
  let locationQueryString = "";
  if (params.pos_ids && params.pos_ids.length > 0) {
    locationQueryString =
      "&pos_ids=" +
      params.pos_ids.map(location => `${location.value}`).join(",");
  } else if (params.pos_id && params.pos_id.length > 0){
    queryString = queryString + `&pos_id=${params.pos_id}`;
  }

  let apiUrl = `/benchmark/daily-total-sales-yoy/?${queryString}${locationQueryString}`;
  if (yearOver != '' && yearOver === 2){
    apiUrl = `/benchmark/daily-total-sales-yo2y/?${queryString}${locationQueryString}`;
  }
  // console.log(apiUrl);
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}


export async function getAnalyticsKPIMetricAvg(params,yearOver) {
  let apiUrl = "";
  params.period = (yearOver == 'ppnoc') ? "day" : 'dayweek';
  params.year_over = yearOver;
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");

  if ('location_ids' in params && params.location_ids.length) {
    let queryStringLocation = params.location_ids
    
    .map(location_id => `location_id=${location_id}`)
    .join("&");

    queryString += '&' + queryStringLocation
  }
  
  apiUrl = `/benchmark/analytics/kpi/avg?${queryString}`;
  if (yearOver == 'ppnoc'){
    apiUrl = `/benchmark/analytics/pos/sales/avg?${queryString}`; ///benchmark/analytics/kpi/avg
  }
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}


export async function getTotalSalesCampaignAnalytics(params, yearOver = '') {
  // console.log("params", params);
  delete params.period;
  let queryString = `start_date=${params.start_date}&end_date=${params.end_date}&period=week&campaign_id=${params.campaign_id}&year_over=${yearOver}`;
  let locationQueryString = "";
  if (params.pos_ids && params.pos_ids.length > 0) {
    locationQueryString =
      "&pos_ids=" +
      params.pos_ids.map(location => `${location.value}`).join(",");
  } else {
    queryString = queryString + `&pos_id=${params.pos_id}`;
  }
  if(params.time_dimension)
  {
    queryString = queryString + `&time_dimension=${params.time_dimension}`;
  }
  if(yearOver == 'ppnoc'){
    queryString += `&abs=1`
  }
  let apiUrl = `/benchmark/weekly-total-sales-campaign-analytics/?${queryString}${locationQueryString}`;  

  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getAllapi(params){
    let apiNewCustomerUrl = '';
    let apiExistingCustomerUrl = '';
    let response = {
        resp1: [],
        resp2: []   
    }

    let baseApiUrl = ''
    // portlet CUSTOMER selected
    if (params.portletSelect == 1 ){ // for customer
        if (params.yearSelect == 1 ){ // for yoy
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/customer-count-yoy-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/customer-count-yoy-weekly/'
            }else{ // monthly
                baseApiUrl = '/benchmark/customer-count-yoy-monthly/'
            }

        } else if(params.yearSelect == 2){ // for yoy2
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/customer-count-yo2y-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/customer-count-yo2y-weekly/'
            }else{ // monthly
                baseApiUrl = '/benchmark/customer-count-yo2y-monthly/'
            }
        } else { // absolute value
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/customer-count-abs-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/customer-count-abs-weekly/'
            }else{ // monthly
                baseApiUrl = '/benchmark/customer-count-abs-monthly/'
            }
        }
    }else{ // for Average customer Check
        if (params.yearSelect == 1 ){ // for yoy
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/avg-customer-check-yoy-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/avg-customer-check-yoy-weekly/'
            }else{ // monthly
                baseApiUrl = '/benchmark/avg-customer-check-yoy-monthly/'
            }

        } else if(params.yearSelect == 2){ // for yoy2
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/avg-customer-check-yo2y-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/avg-customer-check-yo2y-weekly/'
            }else{ // monthly
                baseApiUrl = '/benchmark/avg-customer-check-yo2y-monthly/'
            }
        } else { // absolute value
            if (params.dayBasis == 'daily'){ // for daily
                baseApiUrl = '/benchmark/avg-customer-check-abs-daily/'
            }else if (params.dayBasis == 'weekly'){ // for weekly
                baseApiUrl = '/benchmark/avg-customer-check-abs-weekly'
            }else{ // monthly
                baseApiUrl = '/benchmark/avg-customer-check-abs-monthly/'
            }
        }
    }
    
    let queryString = Object.keys(params.parameterApi.revenueList)
    .map(function (key) {
      return `revenue_center_id=${params.parameterApi.revenueList[key]}`;
    })
    .join("&");
    let queryStringLocation = ''
    if ('location_ids' in params && params.location_ids.length) {
      queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
    }

    if (true) { // monthly
        apiNewCustomerUrl = `${baseApiUrl}?start_date=${params.parameterApi.date.start_date}&end_date=${params.parameterApi.date.end_date}&${queryString}&is_new_customer=false&campaign_id=${params.campaignId}&${queryStringLocation}`
        
        apiExistingCustomerUrl = `${baseApiUrl}?start_date=${params.parameterApi.date.start_date}&end_date=${params.parameterApi.date.end_date}&${queryString}&is_new_customer=true&campaign_id=${params.campaignId}&${queryStringLocation}`
    }

    try {
        const apiResp1 = await getData(apiNewCustomerUrl);
        const apiResp2 = await getData(apiExistingCustomerUrl);
        response.resp1 = apiResp1
        response.resp2 = apiResp2

        return response;
    } catch (e) {
        return null;
    }
}


export async function getRecommendedControlStores(params) {
  try {
    let queryString = Object.keys(params)
      .map(function (key) {
        return `${key}=${params[key]}`;
      })
      .join("&");
    const apiUrl = `/campaigns/other-campaign-control-stores-recommendations/?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaignVsControlStoresMastercard(params) {
  try {
    let yearOption = params.year_option
    let queryString = Object.keys(params).map(function (key) {
      return `${key}=${params[key]}`;
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if(yearOption == 'ppnoc'){
      queryString += `&abs=1`
    }
    const apiUrl = `/benchmark/campaign-vs-control-stores-mastercard/?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaignVsControlStoresPosdata(params) {
  try {
    let yearOption = params.year_option
    let queryString = Object.keys(params).map(function (key) {
      return `${key}=${params[key]}`;
      }).join("&");
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if(yearOption == 'ppnoc'){
      queryString += `&abs=1`
    }
    const apiUrl = `/benchmark/campaign-vs-control-stores-posdata/?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}


export async function getMarketingSummaryView(params) {
  try {
    let queryString = Object.keys(params).map(function (key) {
      return `${key}=${params[key]}`;
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    // let queryString = ''
    const apiUrl = `/benchmark/marketing-summary-view/?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getRFMGraphData(params) {
  try {
    let queryString = Object.keys(params).map(function (key) {
        return `${key}=${params[key]}`;     
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if ('channel_types' in params && params.channel_types.length) {
      let queryStringChannelTypes = params.channel_types.map(channel_type => `channel_type=${channel_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    if ('customer_types' in params && params.customer_types.length) {
      let queryStringChannelTypes = params.customer_types.map(customer_type => `customer_type=${customer_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    // let queryString = ''
    const apiUrl = `/benchmark/rfm-analytics-api/chart?${queryString}`;
    const response = await getData(apiUrl);
    return response;           
  } catch (e) {
    console.log("Error in getRFMGraphData",e) 
    return null;
  }
}

export async function getRFMMarketingRecom(params) {
  try {
    let queryString = Object.keys(params).map(function (key) {
        return `${key}=${params[key]}`;     
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if ('channel_types' in params && params.channel_types.length) {
      let queryStringChannelTypes = params.channel_types.map(channel_type => `channel_type=${channel_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    if ('customer_types' in params && params.customer_types.length) {
      let queryStringChannelTypes = params.customer_types.map(customer_type => `customer_type=${customer_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    // let queryString = ''
    const apiUrl = `/benchmark/rfm-analytics-api/tiles?${queryString}`;
    const response = await getData(apiUrl);
    return response;    
  } catch (e) {
    console.log("Error in getRFMGraphData",e) 
    return null;
  }
}

export async function getBasketRetention(params) {
  try {
    let queryString = Object.keys(params).map(function (key) {
        return `${key}=${params[key]}`;     
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if ('channel_types' in params && params.channel_types.length) {
      let queryStringChannelTypes = params.channel_types.map(channel_type => `channel_type=${channel_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    if ('customer_types' in params && params.customer_types.length) {
      let queryStringChannelTypes = params.customer_types.map(customer_type => `customer_type=${customer_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    if ('menu_items_col' in params && params.menu_items_col.length) {
      let queryStringChannelTypes = params.menu_items_col.map(menu_items_col => `menu_items=${menu_items_col}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    const apiUrl = `/bigdata/basket-analysis-api/table?${queryString}`;
    const response = await getData(apiUrl);

    return response;    
  } catch (e) {
    console.log("Error in getBasketRetention",e) 
    return null;
  }
}

export async function getRFMNewVsRepeatData(params) {
  try {
    let queryString = Object.keys(params).map(function (key) {
        return `${key}=${params[key]}`;     
      }).join("&");
      
    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids.map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
    if ('channel_types' in params && params.channel_types.length) {
      let queryStringChannelTypes = params.channel_types.map(channel_type => `channel_type=${channel_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    if ('customer_types' in params && params.customer_types.length) {
      let queryStringChannelTypes = params.customer_types.map(customer_type => `customer_type=${customer_type}`)
      .join("&");
  
      queryString += '&' + queryStringChannelTypes
    }
    // let queryString = ''
    const apiUrl = `/benchmark/rfm-analytics-api/newvsrepeat?${queryString}`;
    const response = await getData(apiUrl);
    return response;           
  } catch (e) {
    console.log("Error in getRFMNewVsRepeatData",e) 
    return null;
  }
}

export async function getMenuItemCategory() {
  let apiUrl = `/pos/menu-item-category/`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getSample(params,yearOver) {
  let apiUrl = "";
  params.period = "day";
  let queryString = Object.keys(params)
    .map(function (key) {
      return `${key}=${params[key]}`;
    })
    .join("&");

    if ('location_ids' in params && params.location_ids.length) {
      let queryStringLocation = params.location_ids
      
      .map(location_id => `location_id=${location_id}`)
      .join("&");
  
      queryString += '&' + queryStringLocation
    }
  
  apiUrl = `/benchmark/analytics/pos/sales/avg?${queryString}`; ///benchmark/analytics/kpi/avg
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}